import { useBranchFeatures } from '@/api/use-branch-features';

import { useProviderInitializer } from './use-provider-initializer';
import { useSalesforceInitialization } from './use-salesforce-initialization';
import { useSetLeadIntegrationEnabled } from './use-set-lead-integration-enabled';
import { useSetPauseOnMissedCall } from './use-set-pause-on-missed-call';
import { useSetRingTimeout } from './use-set-ring-timeout';

export const useAppInitialization = () => {
  // Keep capability discovery alive while permissions select the app mode.
  useBranchFeatures();
  useProviderInitializer();
  useSalesforceInitialization();
  useSetLeadIntegrationEnabled();
  useSetPauseOnMissedCall();
  useSetRingTimeout();
};
